module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('div', {
    staticClass: "row column card p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Clients"), _c('SearchEntity', {
    staticClass: "mb-1",
    attrs: {
      "entity": "clients",
      "clear-input": "clear-input"
    },
    on: {
      "selected": _vm.add
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(result) {
        return [_c('div', {
          staticClass: "quick-search-result"
        }, [_c('div', [_c('small', [_vm._v("CL" + _vm._s(result.result.id))]), _c('div', [_vm._v(_vm._s(result.result.name) + " " + _vm._s(result.result.surname))]), (result.result.organization_name) ? _c('div', [_c('small', [_vm._v(_vm._s(result.result.organization_name))])]) : _vm._e(), _c('div', [_c('small', [_vm._v(_vm._s(result.result.phone))])])])])]
      }
    }]),
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _c('base-list', {
    ref: "list",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "componentType": "federationList",
      "selectableList": true,
      "resultsPerPage": 5
    },
    model: {
      value: (_vm.selected.delete),
      callback: function($$v) {
        _vm.$set(_vm.selected, "delete", $$v)
      },
      expression: "selected.delete"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [(_vm.selected.delete.length) ? _c('ActionButton', {
    attrs: {
      "action": _vm.save,
      "confirm": "confirm"
    }
  }, [_vm._v("Delete")]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4230edb2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/FederationClientsEdit.vue
// module id = 2446
// module chunks = 1